var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Absolute3DPosition, GeographicalPosition, SerializableMember, SerializableObject, } from '@openhps/core';
import { SymbolicSpace } from './SymbolicSpace';
let Floor = class Floor extends SymbolicSpace {
    constructor() {
        super(...arguments);
        this.groundHeight = undefined;
    }
    setArrayBounds(localBounds) {
        if (localBounds.length > 0 && localBounds[0] instanceof GeographicalPosition) {
            return super.setArrayBounds(localBounds);
        }
        const bounds = localBounds.map((bound) => {
            const vector = bound.toVector3();
            return new Absolute3DPosition(vector.x, vector.y, 0);
        });
        if (this.ceilingHeight) {
            bounds.push(...bounds.map((bound) => {
                const clonedBound = bound.clone();
                clonedBound.z = clonedBound.z + this.ceilingHeight;
                return clonedBound;
            }));
            if (localBounds.length === 2) {
                bounds.splice(1, 2);
            }
        }
        super.setArrayBounds(bounds);
    }
    setBuilding(building) {
        this.parent = building;
        this.priority = building.priority + 1;
        this.updateBounds();
        return this;
    }
    updateBounds() {
        if (this.parent) {
            this.setBounds(this.parent.getLocalBounds());
        }
    }
    setFloorNumber(floor, floorHeight = 3) {
        var _a;
        this.floorLevel = floor;
        this.setGroundHeight((_a = this.groundHeight) !== null && _a !== void 0 ? _a : floor * floorHeight);
        this.setCeilingHeight(floorHeight);
        this.updateBounds();
        return this;
    }
    setHeight(height) {
        return this.setGroundHeight(height);
    }
    setGroundHeight(height) {
        this.groundHeight = height;
        this.translation(0, 0, this.groundHeight);
        return this;
    }
    setCeilingHeight(height) {
        this.ceilingHeight = height;
        return this;
    }
    toGeoJSON(flat) {
        const geojson = super.toGeoJSON(flat);
        geojson.properties.floorLevel = this.floorLevel;
        return geojson;
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], Floor.prototype, "groundHeight", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], Floor.prototype, "floorLevel", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], Floor.prototype, "ceilingHeight", void 0);
Floor = __decorate([
    SerializableObject()
], Floor);
export { Floor };
//# sourceMappingURL=Floor.js.map